export function InvoiceTradeInCtrl (
  $scope,
  $uibModalInstance,
  bodyTypes,
  currencyApi,
  driveTypes,
  franchises,
  fuelTypes,
  sessionObjAPI,
  transmissionTypes,
  vehicleApi
) {

  $scope.bodyTypes         = bodyTypes;
  $scope.currency          = currencyApi.getInfo();
  $scope.driveTypes        = driveTypes;
  $scope.franchises        = franchises;
  $scope.fuelTypes         = fuelTypes;
  $scope.tradeIn           = {};
  $scope.transmissionTypes = transmissionTypes;
  $scope.company           = sessionObjAPI.company();

  if ($scope.company.company_variable_fields.plate_number_name) {
    $scope.regoLabel = $scope.company.company_variable_fields.plate_number_name;
  }
  else {
    $scope.regoLabel = sessionObjAPI.countrySettings().rego_label;
  };

  $scope.save = function () {
    $uibModalInstance.close($scope.tradeIn);
  };

  // user updated the vehicle suggested sale
  // price including tax, so update the price
  // excluding tax.
  $scope.updatePriceExcludingTax = function () {
    $scope.tradeIn.suggested_sale_price =
      vehicleApi.calculatePriceExcludingTax($scope.tradeIn.suggested_sale_price_including_tax);
  };

  // user updated the vehicle suggested sale
  // price excluding tax, so update the price
  // including tax.
  $scope.updatePriceIncludingTax = function () {
    $scope.tradeIn.suggested_sale_price_including_tax =
      vehicleApi.calculatePriceIncludingTax($scope.tradeIn.suggested_sale_price);
  };

  // user updated the value of acquisition
  // including tax, so update the value
  // excluding tax.
  $scope.updateValueExcludingTax = function () {
    $scope.tradeIn.value_of_acquisition =
      vehicleApi.calculatePriceExcludingTax($scope.tradeIn.value_of_acquisition_including_tax);
  };

  // user updated the value of acquisition
  // excluding tax, so update the value
  // including tax.
  $scope.updateValueIncludingTax = function () {
    $scope.tradeIn.value_of_acquisition_including_tax =
      vehicleApi.calculatePriceIncludingTax($scope.tradeIn.value_of_acquisition);
  };
}